import { Controller, useFormContext } from 'react-hook-form';

import {
  DateRangePicker,
  getDefaultPeriodPresets,
} from '~shared/ui/date-range-picker';

import {
  getDefaultPeriodMaxDate,
  getDefaultPeriodMinDate,
} from '~features/period-filter';

import type { OrdersFiltersValue } from '../../model/orders-filters';

const PERIOD_PRESETS = getDefaultPeriodPresets();

type Props = {
  onChange?: () => void;
};

export function OrdersPeriodFilter({ onChange }: Props) {
  const { control } = useFormContext<OrdersFiltersValue>();

  return (
    <Controller
      control={control}
      name="period"
      render={({ field, ...controllerProps }) => (
        <DateRangePicker
          {...controllerProps}
          field={{
            ...field,
            onChange: (period: OrdersFiltersValue['period']) => {
              field.onChange(period);

              const isComplete = Boolean(period.startDate && period.endDate);
              const isCleared = !period.startDate && !period.endDate;

              if (isComplete || isCleared) {
                onChange?.();
              }
            },
          }}
          align="end"
          minDate={getDefaultPeriodMinDate()}
          maxDate={getDefaultPeriodMaxDate()}
          presets={PERIOD_PRESETS}
        />
      )}
    />
  );
}
